const FaqCampaignType = {
    Incentivada: 1,
    SemIncentivoFiscal: 2
};

const FaqCampaignTypeOptions = [
    { value: FaqCampaignType.Incentivada, label: "Incentivada" },
    { value: FaqCampaignType.SemIncentivoFiscal, label: "Sem Incentivo Fiscal" }
];

function getFaqCampaignTypeLabel(value) {
    const found = FaqCampaignTypeOptions.find(o => o.value === value);
    return found ? found.label : "—";
}

export { FaqCampaignType, FaqCampaignTypeOptions, getFaqCampaignTypeLabel };
